// element should have data

$(function (window) {
  var EventTrackingHelper = (function($) {
    var obj = {};
    var local = {};  // <-- Local namespace
    var timeoutDelay = 300;
    obj.trackEvent = function(element, config) {
      local.trackEvent(element, config);
    };

    var createFunctionWithTimeout = local.createFunctionWithTimeout = function(callback, opt_timeout) {
      var called = false;
      function fn() {
        if (!called) {
          called = true;
          callback();
        }
      }
      setTimeout(fn, opt_timeout || timeoutDelay);
      return fn;
    }

    var trackEvent = local.trackEvent = function(element, config) {
      var eventAction = null;
      var hitCallback = null;
      if (!!config.eventActionCallback) {
        var fn = config.eventActionCallback;
        eventAction = local[fn].call();
      } else {
        eventAction = config.eventAction;
      }

      var parameters = {
        hitType: 'event',
        eventCategory: config.eventCategory,
        eventAction: eventAction
      };

      // TODO: Find a way, how regular links can also trigger additional events
      // if (config.trigger === 'click') {
      //   $(element).off('click');
      //   console.log(element);
      //   hitCallback = function() {
      //     document.location = element.href;
      //   }
      // }
      if (config.trigger === 'submit') {
        // we have a submit trigger so we have a form
        parameters.hitCallback = local.createFunctionWithTimeout(function() {
          $(element).off('submit');  
          $(element).submit();
        });
        
      }
      ga('send', parameters);
    };

    var countrySelectValue = local.countrySelectValue = function() {
      return $('#contact_country').val();
    }

    return obj;
  })($);

  window.EventTrackingHelper = EventTrackingHelper;  

  $("[data-behavior=data-tracking]").exists(function ($trackingElements) {
    $trackingElements.each(function (i, element) {
      var $element = $(element);
      var config = $(this).data('tracking');
      var trigger = config.trigger;
      var type = config.type;

      
      if (type === 'event') {
        $element.on(trigger, function(event) {
          if (trigger === 'submit') {
            event.preventDefault();
          }
          EventTrackingHelper.trackEvent( this, config ); 
        });
      }
    });
  });
});